export default __webpack_public_path__ + "static/media/1.ba5213a9.jpg_";